import { useEffect, type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { LoadingPage } from './loading-page';

import { useAuth } from '@/hooks/use-auth';
import { useAuthStore } from '@/stores/auth-store';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { status } = useAuthStore();
  const { checkAuth } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (status === 'idle') {
      checkAuth();
    }
  }, [status, checkAuth]);

  if (status === 'idle' || status === 'loading') {
    return <LoadingPage />;
  }

  if (status === 'unauthenticated') {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
